import * as Toolbar from './components/Toolbar.css';

export default {
	Toolbar
};
